// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"b548d311","145":"9eded381","216":"2d525e35","620":"8e1cd6a6","639":"1aaffea5","686":"842fb32d","715":"900e6e5a","725":"59e8391a","960":"21362a21"}[chunkId] + ".chunk.css";
};